<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-data-table
              no-data-text="Нет заказаов"
              no-results-text="По заданному запросу ничего не найдено"
              v-model="selected"
              :headers="headers"
              :items="user.orders"
              :options.sync="options"
              :footer-props="footerProps"
              :loading="loading"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :item-class="getItemClass"
              :items-per-page="-1"
              loading-text="Загрузка заказов... Подождите пожалуйста"
      >
        <template v-slot:item.id="{ item }">
          <a style="color: #2196F3;" @click.stop="order = item">№ {{ item.id }}</a>
        </template>

      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <order-modal v-model="order"></order-modal>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import OrderModal from "./../../../components/OrderModal";

  export default {
    name: 'OrderTab',
    components: {OrderModal},
    props: {
      value: Object,
      loading: Boolean,
      disabled: Boolean
    },
    data() {
      return {
        user: this.value,
        selected: [],
        filters: {
          category: {
            value: [],
            tempValue: [],
            modal: false,
          },
        },
        overlay: false,
        order: {},
        options: {},
        footerProps: {
          itemsPerPageText: 'Заказов на страницу',
          pageText: '{0}-{1} из {2}',
          itemsPerPageAllText: 'Все',
          itemsPerPageOptions: [15, 30, -1]
        },
        headers: [
          {
            text: 'ID',
            value: 'id',
          },
          {
            text: 'Телефон',
            value: 'phone'
          },
          {
            text: 'Адрес',
            value: 'address',
          },
          {
            text: 'Клиент',
            value: 'client_name',
          },
          {
            text: 'Заказ поступил',
            value: 'created_at',
          },
          {
            text: 'Сумма',
            value: 'sum',
          },
          {
            text: 'Тип оплаты',
            value: 'type_text',
          },
          {
            text: 'Источник заказа',
            value: 'source',
          },
          {
            text: 'Комментарий',
            value: 'comment',
          },
        ],
      }
    },
    mounted() {

    },
    watch: {
    },
    methods: {
      getItemClass(item){
        if(item.hide == 1){
          return 'hidden-product'
        }
      },
    }
  }
</script>

<style lang="scss">
  table{
    tr{
      &.hidden-product{
        background-color: #FFEEEC;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
